<template>
    <div class="relative">
        <div class="">
            <ssr-carousel class="hidden sm:block" paginate-by-slide :slides-per-page='4' :gutter='20' :autoplay-delay="5">
                <div v-for="event in events" :key="event.id">
                    <a :href="`https://eventiosm.it/event/${event.slug}`" class="focus-none">
                        <div class="text-black bg-white border-2 border-gray-200 rounded-md shadow-lg slide">
                            <img :src="`https://eventiosm.it${event.cover}`" class="rounded-t-md">
                            <div class="flex flex-col justify-between px-1 py-2 sm:p-4 cust-height">
                                <h4 class="text-sm font-bold uppercase sm:text-lg">{{ event.title }}</h4>
                                <div class="flex items-center justify-between my-3 text-xs font-semibold sm:text-base">
                                    <div class="text-pink-600">
                                        {{ event.date | moment("DD-MM-YYYY") }}
                                    </div>
                                    <div>
                                        {{ event.city }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </ssr-carousel>
            <ssr-carousel class="block sm:hidden" paginate-by-slide :slides-per-page='2' :gutter='10' :show-dots="true" :autoplay-delay="5">
                <div v-for="event in events" :key="event.id">
                    <a :href="`https://eventiosm.it/event/${event.slug}`" class="focus-none">
                        <div class="text-black bg-white border-2 border-gray-200 rounded-md shadow-lg slide">
                            <img :src="`https://eventiosm.it${event.cover}`" class="rounded-t-md">
                            <div class="flex flex-col justify-between px-1 py-2 sm:p-4 cust-height">
                                <h4 class="text-sm font-bold uppercase sm:text-lg">{{ event.title }}</h4>
                                <div class="flex items-center justify-between my-3 text-xs font-semibold sm:text-base">
                                    <div class="text-pink-600">
                                        {{ event.date | moment("DD-MM-YYYY") }}
                                    </div>
                                    <div>
                                        {{ event.city }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
            </ssr-carousel>
        </div>
    </div>
</template>
 
<script>
    import SsrCarousel from 'vue-ssr-carousel'
    import ssrCarouselCss from 'vue-ssr-carousel/index.css'

    export default {
        props: ['events'],
        components: { SsrCarousel},
    }
</script>
<style scoped>
    .cust-height{
        min-height: 10rem;
    }
</style>